
export { trim as default, trim, ITrimOptions } from '@lazy-cjk/str-util-trim';
